import { createSelector } from 'reselect';
import { NAV_SLIDER_MAP } from '../constants';

type NavComponentKey = string | undefined;

type NavState = {
  navigation: {
    navComponentKey: NavComponentKey;
  };
};

export const selectNavComponentKey = (state: NavState): NavComponentKey =>
  state.navigation.navComponentKey;

export const selectDrawerComponent = createSelector(
  [selectNavComponentKey],
  (key) => NAV_SLIDER_MAP?.[key as keyof typeof NAV_SLIDER_MAP],
);
